import actionTypes from 'app/actions/action-types';
import api from 'app/resources/terms-management.api';

export const fetchTermsOfUseRequest = () => ({
  type: actionTypes.FETCH_CMS_TERMS_OF_USE_REQUEST,
});

export const fetchTermsOfUseFailure = () => ({
  type: actionTypes.FETCH_CMS_TERMS_OF_USE_FAILURE,
});

export const fetchTermsOfUseSuccess = (response) => ({
  type: actionTypes.FETCH_CMS_TERMS_OF_USE_SUCCESS,
  response,
});

export const fetchTermsOfUse = () => async (dispatch, getState) => {
  try {
    const { config } = getState();
    const { jurisdictionId, secondHandApproval } = config;

    const params = {
      jurisdictionId,
      secondHandApproval,
    };

    dispatch(fetchTermsOfUseRequest());
    const response = await api.fetchTermsOfUse(params);
    dispatch(fetchTermsOfUseSuccess(response));
  } catch (error) {
    dispatch(fetchTermsOfUseFailure());
    // eslint-disable-next-line no-console
    console.error('FETCH_CMS_TERMS_OF_USE', error);
  }
};

export const fetchPrivacyPolicyRequest = () => ({
  type: actionTypes.FETCH_CMS_PRIVACY_POLICY_REQUEST,
});

export const fetchPrivacyPolicyFailure = () => ({
  type: actionTypes.FETCH_CMS_PRIVACY_POLICY_FAILURE,
});

export const fetchPrivacyPolicySuccess = (response) => ({
  type: actionTypes.FETCH_CMS_PRIVACY_POLICY_SUCCESS,
  response,
});

export const fetchPrivacyPolicy = () => async (dispatch, getState) => {
  try {
    const { config } = getState();
    const { jurisdictionId, secondHandApproval } = config;

    const params = {
      jurisdictionId,
      secondHandApproval,
    };

    dispatch(fetchPrivacyPolicyRequest());
    const { entries } = await api.fetchPrivacyPolicy(params);
    dispatch(fetchPrivacyPolicySuccess(entries[0]));
  } catch (error) {
    dispatch(fetchPrivacyPolicyFailure());
    // eslint-disable-next-line no-console
    console.error('FETCH_CMS_PRIVACY_POLICY', error);
  }
};

export const clearCmsTerms = () => ({
  type: actionTypes.CLEAR_CMS_TERMS,
});



// WEBPACK FOOTER //
// ./src/modules/app/actions/terms-management.actions.js